import { createApp } from "vue";
import App from "./App.vue";
import router from "@/router";
import Antd from "ant-design-vue";
import "animate.css/animate.css";
import "./index.css";
import "./assets/css/app.min.css";
import "./assets/css/fontawesome.min.css";
import "./assets/css/vendor/remixicon.css";
import "./assets/css/vendor/bootstrap.min.css";
import "./assets/css/vendor/animate.min.css";
import "./assets/css/plugins/swiper.min.css";
import "./assets/css/plugins/nice-select.css";
import "./assets/css/plugins/nouislider.min.css";
import "./assets/css/vendor/magnific-popup.css";
import "./assets/css/vendor/odometer.min.css";
import "./assets/css/vendor/fontawesome-pro.css";
import "./assets/css/vendor/spacing.css";
import "./assets/css/vendor/remixicon.css";
import "./assets/css/main.css";
import "./assets/css/bootstrap-icons.css";
import "./assets/css/css.css";
import { createPinia } from "pinia";

createApp(App)
.use(createPinia())
.use(router)
.use(Antd)
.mount("#app");
